import React, { useEffect } from 'react';
import {
  Hero, PageHeader, BackedBy, Industries, CostOfInaction, AgentSuite, StatsStrip, Testimonial, FinalCta,
} from './sections';

const useTitle = (title) => {
  useEffect(() => { document.title = title; }, [title]);
};

export const HomePage = () => {
  useTitle('Salescot — Your entire sales team, automated forever');
  return (
    <>
      <Hero />
      <BackedBy />
      <Industries />
      <CostOfInaction />
      <AgentSuite />
      <StatsStrip />
      <Testimonial />
      <FinalCta />
    </>
  );
};

export const AgentsPage = () => {
  useTitle('AI Agents — Salescot');
  return (
    <>
      <PageHeader label="AI AGENTS" title="Your sales team, rebuilt as AI agents that never clock out.">
        Email, voice and WhatsApp — three agents that work every lead, in Hindi and English, around the clock.
      </PageHeader>
      <AgentSuite />
      <StatsStrip />
      <FinalCta />
    </>
  );
};

export const ProblemPage = () => {
  useTitle('The Problem — Salescot');
  return (
    <>
      <PageHeader label="THE PROBLEM" title="Every slow reply is a sale your competitor closes.">
        Manual sales teams are expensive, sleep at night and forget follow-ups. Here's what that is quietly costing you.
      </PageHeader>
      <CostOfInaction />
      <Industries />
      <FinalCta />
    </>
  );
};

export const ResultsPage = () => {
  useTitle('Results — Salescot');
  return (
    <>
      <PageHeader label="RESULTS" title="What changes when your sales team runs on Salescot.">
        Faster replies, more outreach and zero salaries — measured across 100+ Indian businesses.
      </PageHeader>
      <StatsStrip />
      <Testimonial />
      <BackedBy />
      <FinalCta />
    </>
  );
};
